export enum ShipmentStatus {
    DRAFT = 'DRAFT',
    COMPLETED = 'COMPLETED',
}
